/* eslint-disable jsx-a11y/click-events-have-key-events */
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React, { useContext } from 'react'

import colorContext from '../../../../Context/colorContext'
import theme from '../../../../services/theme-service'
import { EstatisticI, UserStatistic } from '../..'

interface Props {
  indicators: EstatisticI
  countUsers: UserStatistic
}

export default function Indicators({
  indicators,
  countUsers,
}: Props): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles(() => ({
    main: {
      width: '100%',
      padding: '80px 10px',
      display: 'flex',
      justifyContent: 'center',
      background: colors.colorGradient,
      alignItems: 'center',
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      fontWeight: 'bold',
      color: colors.textAccentColor,
      left: 9,
      bottom: 40,
      fontSize: theme.typography.pxToRem(36),
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 30,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 11,
        marginLeft: -14,
        left: 5,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(28),
        '&::after': {
          bottom: 4,
        },
      },
    },
    line: {
      width: 4,
      height: 50,
      backgroundColor: colors.accentColor,
      marginLeft: 4,
      marginRight: 4,
    },
    box: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      },
    },
    boxTitle: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        // textAlign: 'center',
      },
    },
    numberIndicators: {
      color: colors.textAccentColor,
      fontSize: theme.typography.pxToRem(60),
      fontWeight: 700,
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(40),
      },
    },
    textIndicators: {
      color: colors.textAccentColor,
      maxWidth: 208,
      fontSize: theme.typography.pxToRem(24),
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(20),
      },
    },
  }))
  const classes = useStyles()
  return (
    <Box className={classes.main}>
      <Box display="flex" maxWidth="1320px" width="100%" flexDirection="column">
        <Box className={classes.boxTitle}>
          <Typography className={classes.textTitle} variant="h5" component="h2">
            Indicadores
          </Typography>
        </Box>
        <Box className={classes.box}>
          <Box marginBottom="15px" display="flex" alignItems="center">
            <Typography
              className={classes.numberIndicators}
              variant="h3"
              component="p"
            >
              {indicators?.servicos_total}
            </Typography>
            <Box className={classes.line} />
            <Typography className={classes.textIndicators}>
              SERVIÇOS NO PORTAL
            </Typography>
          </Box>
          <Box marginBottom="15px" display="flex" alignItems="center">
            <Typography
              className={classes.numberIndicators}
              variant="h3"
              component="p"
            >
              {indicators?.servicos_online}
            </Typography>
            <Box className={classes.line} />
            <Typography className={classes.textIndicators}>
              SERVIÇOS DIGITAIS
            </Typography>
          </Box>
          <Box marginBottom="15px" display="flex" alignItems="center">
            <Typography
              className={classes.numberIndicators}
              variant="h3"
              component="p"
            >
              {countUsers?.total_cidadaos || 0}
            </Typography>
            <Box className={classes.line} />
            <Typography className={classes.textIndicators}>
              USUÁRIOS CADASTRADOS
            </Typography>
          </Box>
          <Box marginBottom="15px" display="flex" alignItems="center">
            <Typography
              className={classes.numberIndicators}
              variant="h3"
              component="p"
            >
              {`${Math.round(parseFloat(indicators?.porcentagem_avaliacao))}%`}
            </Typography>
            <Box className={classes.line} />
            <Typography className={classes.textIndicators}>
              AVALIAÇÕES POSITIVAS
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
